// extracted by mini-css-extract-plugin
module.exports = {"projects-dropdown__for-consultants__placeholder":"Placeholder_projects-dropdown__for-consultants__placeholder__8Ku1a"};